import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "@/stores/authStore";
import { OgmaLogo } from "@/components/OgmaLogo";

export function AuthGuard() {
  const hasHydrated = useAuthStore((s) => s.hasHydrated);
  const basicAuthHeader = useAuthStore((s) => s.basicAuthHeader);

  if (!hasHydrated) {
    return (
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-muted/40">
        <OgmaLogo size={40} />
        <Loader2 className="size-5 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (!basicAuthHeader) return <Navigate to="/login" replace />;
  return <Outlet />;
}
